import { apiClient, APIResponse, extractApiError, buildQuery } from './api';

/**
 * Financial accounts API wrappers (Phase 3).
 *
 * Pagination is disabled server-side for accounts (small per-user lists), so
 * responses are always plain arrays.
 */

export function normalizeAccountList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export const accountsAPI = {
  async listAccounts(params) {
    try {
      const { data } = await apiClient.get(
        `/financial-accounts/${buildQuery(params)}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar as contas.'),
      );
    }
  },

  async createAccount(payload) {
    try {
      const { data } = await apiClient.post('/financial-accounts/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar a conta.'),
      );
    }
  },

  async updateAccount(id, payload) {
    try {
      const { data } = await apiClient.patch(
        `/financial-accounts/${id}/`,
        payload,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar a conta.'),
      );
    }
  },

  async archiveAccount(id) {
    try {
      const { data } = await apiClient.post(
        `/financial-accounts/${id}/archive/`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível arquivar a conta.'),
      );
    }
  },

  async restoreAccount(id) {
    try {
      const { data } = await apiClient.post(
        `/financial-accounts/${id}/restore/`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível reactivar a conta.'),
      );
    }
  },

  async deleteAccount(id) {
    try {
      await apiClient.delete(`/financial-accounts/${id}/`);
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível apagar a conta.'),
      );
    }
  },
};
